export const lazy = (cmPromise: Promise<any>) => () => cmPromise.then(c => c.default)
